import React, { Component, useState } from "react";
import axios from "axios";
import { Box } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import { Form } from "react-bulma-components";

import { Icon } from "react-bulma-components";
import { Button } from "react-bulma-components";
import { Heading } from "react-bulma-components";
import CustomerRentalRecord from "./CustomerRentalRecord";
import { useDispatch, useSelector } from "react-redux";
import { createSetContactDataAction } from "../../actions/dataActions";
import { useContactData } from "../../hooks/useContactData";
import {getContactData} from "../../state/selectors";
import Spinner from "react-spinner-material/lib";
import Collapsible from "react-collapsible";
import ContactInfoSection from "./ContactInfoSection";
import DeleteWarningModal from "../Modal/DeleteWarningModal";
import TypeChangeModal from "./TypeChangeModal";
import Supplier from "./SupplierSection";
import Customer from "./CustomerSection";
import qs from "qs";
import { Table } from "react-bulma-components";
import Instruction from "./Instruction";
import shortid from "shortid";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPoundSign} from "@fortawesome/free-solid-svg-icons";
import MovementDetails from "./MovementDetails";
import {NotificationManager} from "react-notifications";
import {formatXeroData, sendXeroData} from "../../utils";
import useSelect from "../../hooks/useSelect";
import InsuranceInfo from "./InsuranceInfo";
import CashSales from "./CashSales";

function ContactForm({ match, location, endpoint, history }) {
  const dispatch = useDispatch();
  const id = match.params.contact;
  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });

  const complete = useContactData(id, 1, queryParams.type);
  const contact = useSelector(getContactData);
  const [modalOpen, setModalOpen] = useState(false);

  const [typeModalOpen, setTypeModalOpen] = useState(false);
  const [targetType, setTargetType] = useState();

  const phoneTypeOptions = [
      {name: "Landline", value: "Phone"},
      {name: "Mobile", value: "Mobile"},
      {name: "Fax", value: "Fax"}
  ]

  const handleChange = e => {
    dispatch(createSetContactDataAction({ [e.target.name]: e.target.value }));
  };

  const onDeactivatedCheck = e => {
    const toUpdate = {
      target: {
        name: e.target.name,
        value: !contact[e.target.name]
      }
    };
    handleChange(toUpdate)
  }


  const handleCheckbox = e => {
    const {name, checked} = e.target
    dispatch(createSetContactDataAction({ [name]: checked }));
  };

  const setType = type => {
    if (!id) {
      dispatch(createSetContactDataAction({ contact_type: type }));
    } else {
      setTargetType(type);
      setTypeModalOpen(true);
    }
    if(type === "SP"){
      dispatch(createSetContactDataAction({partial_contact: false}))
    }
  };

  const setActive = active => {
      dispatch(createSetContactDataAction({ accounts_active: active }));
  };
  // if (queryParams.type) {
  //   dispatch(createSetContactDataAction({ contact_type: queryParams.type }));
  // }

  const addRentalInstruction = e => {
    e.preventDefault();
    dispatch(createSetContactDataAction({
      rental_instructions: contact.rental_instructions.concat({
        key: shortid.generate(),
        text: ""
      })
    }))
  };

  const updateRentalInstructions = (instruction, index) => {
    let newInstructions = [...contact.rental_instructions];
    newInstructions.splice(index, 1, instruction);
    dispatch(createSetContactDataAction({ rental_instructions: newInstructions }));
  };

  const removeRentalInstruction = index => {
    let newInstructions = [...contact.rental_instructions];
    newInstructions.splice(index, 1);
    dispatch(createSetContactDataAction({ rental_instructions: newInstructions }));
  };

  const addWorkshopInstruction = e => {
    e.preventDefault();
    dispatch(createSetContactDataAction({
      workshop_instructions: contact.workshop_instructions.concat({
        key: shortid.generate(),
        text: "",
        on_completion: false
      })
    }))
  };

  const updateWorkshopInstructions = (instruction, index) => {
    let newInstructions = [...contact.workshop_instructions];
    newInstructions.splice(index, 1, instruction);
    dispatch(createSetContactDataAction({ workshop_instructions: newInstructions }));
  };

  const removeWorkshopInstruction = index => {
    let newInstructions = [...contact.workshop_instructions];
    newInstructions.splice(index, 1);
    dispatch(createSetContactDataAction({ workshop_instructions: newInstructions }));
  };

  const handleDelete = e => {
    e.preventDefault();
    const url = endpoint + "contacts/" + contact.id;
    const conf = { method: "delete", url };
    axios(conf).then(response => history.push("/contacts"));
  };

  const fillCode = (codeName) => {
    const map = {
      workshop_account_code: "02",
      deposit_account_code: "03",
      hire_account_code: "01",
      sale_account_code: "04",
      loan_account_code: "06",
      part_account_code: "05",
      court_account_code: "07",
      movement_account_code: "08"
    }
    const toUpdate = {
      target: {
        name: codeName,
        value: map[codeName]
      }
    };
    handleChange(toUpdate)
  }

  const validator = (data, type) => {
    if(data.partial_contact){
      let codeFields = ['workshop_account_code', 'deposit_account_code', 'hire_account_code', 'sale_account_code', 'loan_account_code', 'part_account_code', 'court_account_code'];
      let valid = true;
      let codeCount = 0
      codeFields.forEach((field) => {
        if (data[field]) {
          codeCount++;
        }
      });
      if (codeCount <= 0) {
        // Only 1 code is needed to make the contact valid
        valid = false;
      }
      if(data.display_name && data.company_email && data.company_phone && data.company_name && data.address_line1 && (valid || data.contact_type === "SP")){
        return true
      } else {
        NotificationManager.warning("Display Name, Company Name, Company Phone, Company Email, Street Address and at least 1 Account Code are required")
        return false
      }
    }
    else {
      if (data.contact_type === "SP") {
        let validPhone = !!(data.company_phone && !!data.company_phone_type)
        if (data.company_phone_type === "Phone") {
          validPhone = validPhone && !!data.company_phone_area_code;
        }
        if (data.company_phone_type === "Phone" || data.company_phone_type === "Mobile") {
          validPhone = validPhone && !!data.company_phone_country_code;
        }
        let validAddress = !!(data.address_line1 && data.town && data.region && data.postcode && data.country);
        if (!!data.display_name && !!data.company_email && (!!data.supplier_payment_terms || data.supplier_payment_terms === 0) && validPhone && validAddress) {
              return true
        } else{
          NotificationManager.warning("Company Phone, Email, Area Code, Country Code, Address, Town, Region, Postcode, Country and Name, Display Name, Supplier Payment Terms are required")
        }
      } else if (data.contact_type === "CC") {
        let codeFields = ['workshop_account_code', 'deposit_account_code', 'hire_account_code', 'sale_account_code', 'loan_account_code', 'part_account_code', 'court_account_code', 'movement_account_code'];
        let valid = true;
        let codeCount = 0
        codeFields.forEach((field) => {
          if (data[field]) {
            codeCount++;
          }
        });
        if (codeCount <= 0) {
          // Only 1 code is needed to make the contact valid
          valid = false;
        }
        let validPhone = !!(data.company_phone && !!data.company_phone_type)
        if (data.company_phone_type === "Phone") {
          validPhone = validPhone && !!data.company_phone_area_code
        }
        if (data.company_phone_type === "Phone" || data.company_phone_type === "Mobile") {
          validPhone = validPhone && !!data.company_phone_country_code
        }
        let validAddress = !!(data.address_line1 && data.town && data.region && data.postcode && data.country);
        if (!!data.display_name &&
            !!data.company_email &&
            (!!data.payment_term_days || data.payment_term_days === 0) &&
            validPhone &&
            validAddress &&
            valid) {
          return true
        }
        NotificationManager.warning("Display Name, Company Information, Payment Term Days and Account Codes are required")
        return false
      }
    }
  };

  const sendData = () => {
    let contacts = formatXeroData(contact, contact.contact_type); // returns array
    let target;
    let promises = []
    if(contact.contact_type === "SP"){
      target = "Supplier"
    }
    else if(contact.contact_type === "CC"){
      target = "Customer"
    }

    contacts.forEach((c) => {
      promises.push(sendXeroData(c, target))
    })
    Promise.all(promises).then((res) => {
      NotificationManager.success("All data has been sent to Xero");
    })
    console.log(contacts);
  }

  const handleSubmit = e => {
    e.preventDefault();
    if(validator(contact, contact.contact_type)) {
      const url = contact.id
          ? `${endpoint}contacts/${contact.id}`
          : `${endpoint}contacts`;
      const method = contact.id ? "put" : "post";

      const conf = {
        method: method,
        data: contact,
        url
      };

      axios(conf).then(response => {
        if (contact.id) {
          createSetContactDataAction(response.data);
        } else {
          let contacts = formatXeroData(response.data, response.data.contact_type); // returns array
          let target;
          let promises = []
          if(response.data.contact_type === "SP"){
            target = "Supplier"
          }
          else if(response.data.contact_type === "CC"){
            target = "Customer"
          }
          if(!response.data.partial_contact) {
            contacts.forEach((contact) => {
             promises.push(sendXeroData(contact, target))
            })
            Promise.all(promises).then((res) => {
             NotificationManager.success("All data has been sent to Xero");
            })
            console.log(contacts);
          }
          history.push("/editcontact/" + response.data.id);
        }
      });
    }
  };

  if (!complete) {
    return (
      <Box>
        <Spinner
          className="spinner-centre"
          size={120}
          color={"#3273dc"}
          stroke={5}
        />
      </Box>
    );
  }

  document.title = "Contact - " + (contact.display_name ? contact.display_name : "New");

  return (
    <div>
      <Box>
        <Columns>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Display Name</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="display_name"
                  onChange={handleChange}
                  value={contact.display_name}
                  required
                  disabled={!!contact.id}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field className="has-addons">
              <Form.Control>
                <Form.Label>Type</Form.Label>
                <Button
                  color={contact.contact_type === "CC" ? "primary" : ""}
                  onClick={() => setType("CC")}
                >
                  Customer
                </Button>
                <Button
                  color={contact.contact_type === "SP" ? "primary" : ""}
                  onClick={() => setType("SP")}
                >
                  Supplier
                </Button>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          {contact.contact_type === "CC" &&
          <Columns.Column>
            <Form.Label>Cash Sale Account</Form.Label>
            <Form.Checkbox
              name={"is_cash_sale"}
              checked={contact.is_cash_sale}
              onClick={onDeactivatedCheck}
            />
          </Columns.Column>
          }
          <Columns.Column>
            <Form.Label>Partial Set Up</Form.Label>
            <Form.Checkbox
              name={"partial_contact"}
              checked={contact.partial_contact}
              onClick={onDeactivatedCheck}
            />
          </Columns.Column>
          <Columns.Column>
            <Form.Label>Deactivated</Form.Label>
            <Form.Checkbox
              name={"deactivated"}
              checked={contact.deactivated}
              onClick={onDeactivatedCheck}
            />
          </Columns.Column>
        </Columns>
      </Box>
      <Box>
        <h1 className="title">Contact Info</h1>
        <Columns>
          <Columns.Column>
            <Form.Field>
              <Form.Label className="label">First Name</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="first_name"
                  onChange={handleChange}
                  value={contact.first_name}
                  required
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <label className="label">Last Name</label>
              <Form.Control>
                <Form.Input
                  className="input"
                  type="text"
                  name="last_name"
                  onChange={handleChange}
                  value={contact.last_name}
                  required
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Contact Number</Form.Label>
              <Form.Control>
                <Form.Input
                  type="tel"
                  name="contact_number"
                  onChange={handleChange}
                  value={contact.contact_number}
                  required
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>Email</Form.Label>
                <Form.Input
                  type="email"
                  name="email"
                  onChange={handleChange}
                  value={contact.email}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
        </Columns>
      </Box>
      <Box>
        <Collapsible
          className="title"
          triggerOpenedClassName="title"
          trigger="Additional Contacts"
        >
          <ContactInfoSection
            contactList={contact.additional_contacts}
            propertyName="additional_contacts"
            includeAddress
            showLicenceInfo
          />
        </Collapsible>
      </Box>
      <InsuranceInfo insuranceList={contact.insurance_info}/>
      <Box>
        <h1 className="title">Company Info</h1>
        <Columns>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>Name (*)</Form.Label>
                <Form.Input
                  type="text"
                  name="company_name"
                  onChange={handleChange}
                  value={contact.company_name}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>Email (*)</Form.Label>
                <Form.Input
                  type="email"
                  name="company_email"
                  onChange={handleChange}
                  value={contact.company_email}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <Form.Label>Phone Type (*)</Form.Label>
            <Form.Select
              name={"company_phone_type"}
              value={contact.company_phone_type}
              onChange={handleChange}
            >
              {phoneTypeOptions.map((option) => (
                  <option value={option.value}>{option.name}</option>
              ))}
            </Form.Select>
          </Columns.Column>
          {contact.company_phone_type === "Phone" &&
            <Columns.Column>
              <Form.Label>{contact.partial_contact ? "Area Code" : "Area Code (*)"}</Form.Label>
              <Form.Input
                name={"company_phone_area_code"}
                type={"text"}
                value={contact.company_phone_area_code}
                onChange={handleChange}
              />
            </Columns.Column>
          }
          {(contact.company_phone_type === "Phone" || contact.company_phone_type === "Mobile") &&
            <Columns.Column>
              <Form.Label>{contact.partial_contact ? "Country Code" : "Country Code (*)"}</Form.Label>
              <Form.Input
                name={"company_phone_country_code"}
                type={"text"}
                value={contact.company_phone_country_code}
                onChange={handleChange}
              />
            </Columns.Column>
          }
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>Phone Number (*)</Form.Label>
                <Form.Input
                  type="text"
                  name="company_phone"
                  onChange={handleChange}
                  value={contact.company_phone}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>{contact.partial_contact ? "Street Address" : "Street Address (*)"}</Form.Label>
                <Form.Input
                  type="text"
                  name="address_line1"
                  onChange={handleChange}
                  value={contact.address_line1}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>{contact.partial_contact ? "Town/City" : "Town/City (*)"}</Form.Label>
                <Form.Input
                  type="text"
                  name="town"
                  onChange={handleChange}
                  value={contact.town}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>{contact.partial_contact ? "Postcode" : "Postcode (*)"}</Form.Label>
                <Form.Input
                  type="text"
                  name="postcode"
                  onChange={handleChange}
                  value={contact.postcode}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>{contact.partial_contact ? "Region" : "Region (*)"}</Form.Label>
                <Form.Input
                  type="text"
                  name="region"
                  onChange={handleChange}
                  value={contact.region}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>{contact.partial_contact ? "Country" : "Country (*)"}</Form.Label>
                <Form.Input
                  type="text"
                  name="country"
                  onChange={handleChange}
                  value={contact.country}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>Company Registration Number</Form.Label>
                <Form.Input
                  type="text"
                  name="company_registration_no"
                  onChange={handleChange}
                  value={contact.company_registration_no}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>VAT Number</Form.Label>
                <Form.Input
                  type="text"
                  name="vat_no"
                  onChange={handleChange}
                  value={contact.vat_no}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
        </Columns>
      </Box>
      <Box>
        <h1 className="title">Accounts</h1>
        <Columns>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Direct Van Hire Credit Limit</Form.Label>
              <Form.Control>
                <Form.Input
                  className="input"
                  type="number"
                  name="direct_van_hire_credit_limit"
                  onChange={handleChange}
                  value={contact.direct_van_hire_credit_limit}
                />
                <Icon align={"left"} className={"small-icon"}>
                  <FontAwesomeIcon icon={faPoundSign}/>
                </Icon>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Rapid Fit Credit Limit</Form.Label>
              <Form.Control>
                <Form.Input
                  className="input"
                  type="number"
                  name="rapid_fit_credit_limit"
                  onChange={handleChange}
                  value={contact.rapid_fit_credit_limit}
                />
                <Icon align={"left"} className={"small-icon"}>
                  <FontAwesomeIcon icon={faPoundSign}/>
                </Icon>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Van Sales Direct Credit Limit</Form.Label>
              <Form.Control>
                <Form.Input
                  className="input"
                  type="number"
                  name="van_sales_direct_credit_limit"
                  onChange={handleChange}
                  value={contact.van_sales_direct_credit_limit}
                />
                <Icon align={"left"} className={"small-icon"}>
                  <FontAwesomeIcon icon={faPoundSign}/>
                </Icon>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Direct Vehicle Recovery Credit Limit</Form.Label>
              <Form.Control>
                <Form.Input
                  className="input"
                  type="number"
                  name="direct_vehicle_recovery_credit_limit"
                  onChange={handleChange}
                  value={contact.direct_vehicle_recovery_credit_limit}
                />
                <Icon align={"left"} className={"small-icon"}>
                  <FontAwesomeIcon icon={faPoundSign}/>
                </Icon>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Outstanding Balance</Form.Label>
              <Form.Control>
                <Form.Input
                  className="input"
                  type="number"
                  name="outstanding_balance"
                  onChange={handleChange}
                  value={contact.outstanding_balance}
                />
                <Icon align={"left"} className={"small-icon"}>
                  <FontAwesomeIcon icon={faPoundSign}/>
                </Icon>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>Payment Terms</Form.Label>
                <Form.Input
                  type="text"
                  name="payment_terms"
                  onChange={handleChange}
                  value={contact.payment_terms}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>Payment Term Days</Form.Label>
                <Form.Input
                  type="number"
                  name="payment_term_days"
                  onChange={handleChange}
                  value={contact.payment_term_days}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Form.Label>Payment Method</Form.Label>
                <Form.Input
                  type="text"
                  name="payment_method"
                  onChange={handleChange}
                  value={contact.payment_method}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <Form.Label>Direct Van Hire Credit Usage</Form.Label>
            <Form.Input
              name={"direct_van_hire_credit_usage"}
              value={contact.direct_van_hire_credit_usage}
              disabled={true}
            />
          </Columns.Column>
          <Columns.Column>
            <Form.Label>Rapid Fit Credit Usage</Form.Label>
            <Form.Input
              name={"rapid_fit_credit_usage"}
              value={contact.rapid_fit_credit_usage}
              disabled={true}
            />
          </Columns.Column>
          <Columns.Column>
            <Form.Label>Van Sales Direct Credit Usage</Form.Label>
            <Form.Input
              name={"van_sales_direct_credit_usage"}
              value={contact.van_sales_direct_credit_usage}
              disabled={true}
            />
          </Columns.Column>
          <Columns.Column>
            <Form.Label>Direct Vehicle Recovery Credit Usage</Form.Label>
            <Form.Input
              name={"direct_vehicle_recovery_credit_usage"}
              value={contact.direct_vehicle_recovery_credit_usage}
              disabled={true}
            />
          </Columns.Column>
          <Columns.Column></Columns.Column>
          <Columns.Column></Columns.Column>
          <Columns.Column></Columns.Column>
          <Columns.Column></Columns.Column>
        </Columns>
        {contact.contact_type === "CC" &&
        <Columns>
          <Columns.Column>
            <Form.Label>Workshop Account Number</Form.Label>
            <Form.Field className={"has-addons"}>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="workshop_account_code"
                  onChange={handleChange}
                  value={contact.workshop_account_code}
                  disabled={true}
                />
              </Form.Control>
              <Button
                  color={"info"}
                  onClick={() => fillCode("workshop_account_code")}
              >
                  Fill
              </Button>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Label>Part Account Number</Form.Label>
            <Form.Field className={"has-addons"}>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="part_account_code"
                  onChange={handleChange}
                  value={contact.part_account_code}
                  disabled={true}
                />
              </Form.Control>
              <Button
                  color={"info"}
                  onClick={() => fillCode("part_account_code")}
              >
                  Fill
              </Button>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Label>Movement Account Number</Form.Label>
            <Form.Field className={"has-addons"}>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="movement_account_code"
                  onChange={handleChange}
                  value={contact.movement_account_code}
                  disabled={true}
                />
              </Form.Control>
              <Button
                  color={"info"}
                  onClick={() => fillCode("movement_account_code")}
              >
                  Fill
              </Button>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Label>Vehicle Sale Account Number</Form.Label>
            <Form.Field className={"has-addons"}>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="sale_account_code"
                  onChange={handleChange}
                  value={contact.sale_account_code}
                  disabled={true}
                />
              </Form.Control>
              <Button
                  color={"info"}
                  onClick={() => fillCode("sale_account_code")}
              >
                  Fill
              </Button>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Label>Loan Account Number</Form.Label>
            <Form.Field className={"has-addons"}>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="loan_account_code"
                  onChange={handleChange}
                  value={contact.loan_account_code}
                  disabled={true}
                />
              </Form.Control>
              <Button
                  color={"info"}
                  onClick={() => fillCode("loan_account_code")}
              >
                  Fill
              </Button>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Label>Hire Account Number</Form.Label>
            <Form.Field className={"has-addons"}>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="hire_account_code"
                  onChange={handleChange}
                  value={contact.hire_account_code}
                  disabled={true}
                />
              </Form.Control>
              <Button
                  color={"info"}
                  onClick={() => fillCode("hire_account_code")}
              >
                  Fill
              </Button>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Label>Deposit Account Number</Form.Label>
            <Form.Field className={"has-addons"}>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="deposit_account_code"
                  onChange={handleChange}
                  value={contact.deposit_account_code}
                  disabled={true}
                />
              </Form.Control>
              <Button
                  color={"info"}
                  onClick={() => fillCode("deposit_account_code")}
              >
                  Fill
              </Button>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Label>Court Account Number</Form.Label>
            <Form.Field className={"has-addons"}>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="court_account_code"
                  onChange={handleChange}
                  value={contact.court_account_code}
                  disabled={true}
                />
              </Form.Control>
              <Button
                  color={"info"}
                  onClick={() => fillCode("court_account_code")}
              >
                  Fill
              </Button>
            </Form.Field>
          </Columns.Column>
          <Columns.Column></Columns.Column>
        </Columns>
        }
        <Columns>
          <Columns.Column>
            <Heading size={6}>Workshop Instructions</Heading>
            <Table>
              <thead>
              <tr>
                <th>Instruction</th>
                <th>On Completion of Job</th>
                <th>Remove</th>
              </tr>
              </thead>
              {contact.workshop_instructions.map((value, index) => (
                <Instruction
                  contact={contact.id}
                  key={value.id || value.key}
                  index={index}
                  instruction={value}
                  updateInstructions={updateWorkshopInstructions}
                  removeInstruction={removeWorkshopInstruction}
                  type={"Workshop"}
                />
              ))}
            </Table>
            <Columns>
              <Columns.Column>
                <Button
                  id="add-workitem"
                  color="info"
                  onClick={addWorkshopInstruction}
                >
                  Add Workshop Instruction
                </Button>
              </Columns.Column>
            </Columns>
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <Heading size={6}>Rental Instructions</Heading>
            <Table>
              <thead>
              <tr>
                <th>Instruction</th>
                <th>Remove</th>
              </tr>
              </thead>
              {contact.rental_instructions.map((value, index) => (
                <Instruction
                  contact={contact.id}
                  key={value.id || value.key}
                  index={index}
                  instruction={value}
                  updateInstructions={updateRentalInstructions}
                  removeInstruction={removeRentalInstruction}
                  type={"Rental"}
                />
              ))}
            </Table>
            <Columns>
              <Columns.Column>
                <Button
                  id="add-workitem"
                  color="info"
                  onClick={addRentalInstruction}
                >
                  Add Rental Instruction
                </Button>
              </Columns.Column>
            </Columns>
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <Form.Field className="has-addons">
              <Form.Control>
                <Form.Label>Status</Form.Label>
                <Button
                  color={!contact.accounts_active ? "primary" : ""}
                  onClick={() => setActive(false)}
                >
                  Inactive
                </Button>
                <Button
                  color={contact.accounts_active ? "primary" : ""}
                  onClick={() => setActive(true)}
                >
                  Active
                </Button>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
              <Form.Label>Account Form Sent</Form.Label>
              <Form.Checkbox
                name={"accounts_form_sent"}
                checked={contact.accounts_form_sent}
                onChange={handleCheckbox}
              />
          </Columns.Column>
          <Columns.Column></Columns.Column>
          <Columns.Column></Columns.Column>
          <Columns.Column></Columns.Column>
        </Columns>
      </Box>
      <Box>
        <Collapsible
            className={"title"}
            triggerOpenedClassName={"title"}
            trigger={"Contact Notes"}
        >
          <Columns>
            <Columns.Column>
              <Form.Textarea
                name={"free_text"}
                onChange={handleChange}
                value={contact.free_text}
              />
            </Columns.Column>
          </Columns>
        </Collapsible>
      </Box>
      {contact.contact_type === "SP" && (
        <Box>
          <Collapsible
            className="title"
            triggerOpenedClassName="title"
            trigger="Workshop Contact Details"
          >
            <Heading size={5}>Primary Workshop Contact</Heading>
            <Columns>
              <Columns.Column>
                <Form.Field>
                  <Form.Control>
                    <Form.Label>Name</Form.Label>
                    <Form.Input
                      type="text"
                      name="workshop_name"
                      onChange={handleChange}
                      value={contact.workshop_name}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Field>
                  <Form.Control>
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Input
                      type="text"
                      name="workshop_contact_number"
                      onChange={handleChange}
                      value={contact.workshop_contact_number}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Field>
                  <Form.Control>
                    <Form.Label>Email</Form.Label>
                    <Form.Input
                      type="email"
                      name="workshop_email"
                      onChange={handleChange}
                      value={contact.workshop_email}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
            </Columns>
            <Columns>
              <Columns.Column>
                <Form.Field>
                  <Form.Control>
                    <Form.Label>Comments</Form.Label>
                    <Form.Input
                      type="text"
                      name="workshop_comments"
                      onChange={handleChange}
                      value={contact.workshop_comments}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
            </Columns>
            <Heading size={5}>Additional Workshop Contacts</Heading>
            <ContactInfoSection
              contactList={contact.workshop_contacts}
              propertyName="workshop_contacts"
            />
          </Collapsible>
        </Box>
      )}
      {contact.contact_type === "SP" && (
        <Box>
          <Collapsible
            className="title"
            triggerOpenedClassName="title"
            trigger="Parts Desk Contact Details"
          >
            <Heading size={5}>Primary Parts Contact</Heading>
            <Columns>
              <Columns.Column>
                <Form.Field>
                  <Form.Control>
                    <Form.Label>Name</Form.Label>
                    <Form.Input
                      type="text"
                      name="parts_name"
                      onChange={handleChange}
                      value={contact.parts_name}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Field>
                  <Form.Control>
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Input
                      type="text"
                      name="parts_contact_number"
                      onChange={handleChange}
                      value={contact.parts_contact_number}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Field>
                  <Form.Control>
                    <Form.Label>Email</Form.Label>
                    <Form.Input
                      type="email"
                      name="parts_email"
                      onChange={handleChange}
                      value={contact.parts_email}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
            </Columns>
            <Columns>
              <Columns.Column>
                <Form.Field>
                  <Form.Control>
                    <Form.Label>Comments</Form.Label>
                    <Form.Input
                      type="text"
                      name="parts_comments"
                      onChange={handleChange}
                      value={contact.parts_comments}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
            </Columns>
            <Heading size={5}>Additional Parts Contacts</Heading>
            <ContactInfoSection
              contactList={contact.part_contacts}
              propertyName="part_contacts"
            />
          </Collapsible>
        </Box>
      )}
      {contact.contact_type === "CC" && (<MovementDetails contact={contact} onChange={handleChange}/>)}
      {contact.contact_type === "CC" && (
        <Customer contact={contact} handleChange={handleChange} handleCheckbox={handleCheckbox} />
      )}
      {contact.contact_type === "SP" && (
        <Supplier contact={contact} handleChange={handleChange} handleCheckbox={handleCheckbox}/>
      )}
      {contact.contact_type === "CC" && contact.id && (
        <CustomerRentalRecord customer={contact.id} />
      )}
      {contact.is_cash_sale &&
        <CashSales data={contact.cash_sales}/>
      }
      <Box>
        <Form.Field>
          <Form.Control>
            <Button onClick={handleSubmit} fullwidth type="submit" color="success">
              Save Contact
            </Button>
          </Form.Control>
        </Form.Field>
        <Form.Field>
          <Form.Control>
            <Button disabled={contact.partial_contact} onClick={sendData} fullwidth type="submit" color="info">
              Send Data to Xero
            </Button>
          </Form.Control>
        </Form.Field>
        {contact.id && false && (
          <Form.Field>
            <Form.Control>
              <Button
                onClick={() => {
                  setModalOpen(true);
                }}
                fullwidth
                type="submit"
                color="danger"
              >
                Delete Contact
              </Button>
            </Form.Control>
          </Form.Field>
        )}
      </Box>
      <DeleteWarningModal
        open={modalOpen}
        setOpen={setModalOpen}
        onDelete={handleDelete}
      />
      <TypeChangeModal
        open={typeModalOpen}
        setOpen={setTypeModalOpen}
        targetType={targetType}
      />
    </div>
  );
}

export default ContactForm;
